export default __webpack_public_path__ + "static/media/bronze-wheel.465641d1.png";